import ReturnTutorialCwalk from '../../components/ReturnTutorialCwalkStaff';

export default function ReturnTutorial() {
    return (
      <div>
        <ReturnTutorialCwalk />
      </div>
    )
  }